import type { RouteRecordRaw } from "vue-router";

import EditQuote from "@/views/EditQuote.vue";
import ListQuotes from "@/views/ListQuotes.vue";
import SizingQuotes from "@/views/SizingQuotes.vue";

const quotesRoutes: Array<RouteRecordRaw> = [
  {
    path: "/quotes",
    name: "ListQuotes",
    component: ListQuotes,
    meta: {
      title: "List Quotes",
      requiresAuth: true
    }
  },
  {
    path: '/quote/:quoteId',
    name: "EditQuote",
    redirect: (to) => {
      // Automatically redirect to sales info tab by default
      return `/quote/${to.params.quoteId}/salesinfo`;
    },
    children: [
      {
        path: "salesinfo",
        name: "EditQuoteSalesInfo",
        component: EditQuote,
        props: (route) => ({ quoteId: route.params.quoteId }),
        meta: {
          title: "Edit Quote - Sales Info",
          requiresAuth: true
        }
      },
      {
        path: "quote",
        name: "EditQuoteQuote",
        component: EditQuote,
        props: (route) => ({ quoteId: route.params.quoteId }),
        meta: {
          title: "Edit Quote - Quote",
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: "/quote/new",
    name: "QuoteNew",
    redirect: () => {
      // Automatically redirect to sales info tab by default
      return `/quote/new/salesinfo`;
    },
    children: [
      {
        path: "salesinfo",
        name: "QuoteNewSalesInfo",
        component: EditQuote,
        meta: {
          title: "New Quote - Sales Info",
          requiresAuth: true
        }
      },
      {
        path: "quote",
        name: "QuoteNewQuote",
        component: EditQuote,
        meta: {
          title: "New Quote - Quote",
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: "/sizings/:sizingId/quotes",
    name: "SizingQuotes",
    component: SizingQuotes,
    props: (route) => ({
      sizingId: route.params.sizingId
    }),
    meta: {
      title: "View/Create Quotes On Sizing",
      requiresAuth: true
    }
  }
];

export default quotesRoutes;
